<template>
  <div class="col-md-6 col-sm-12 hidden-xs align-right footer-bottom">
    <a href="mailto:stonavsky@kovosport.cz">stonavsky@kovosport.cz</a>&nbsp;+420 603 573 882
  </div>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// FooterContact.vue?a5457346